<template>
  <div>
    <v-layout wrap justify-end :style="{ margin: '-4px' }">
      <v-flex shrink class="pa-1">
        <v-btn outline color="grey" class="ma-0" @click="exportData">
          <v-icon>ios_share</v-icon>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
      <v-flex shrink class="pa-1">
        <v-btn
          color="primary"
          class="ma-0"
          @click="isAdvancedSearchVisible = !isAdvancedSearchVisible"
        >
          <v-icon>search</v-icon>
          {{ $t('advanced search') }}
          <v-icon>{{
            isAdvancedSearchVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <AdvancedSearch
      v-if="isAdvancedSearchVisible"
      v-model="filters"
      class="mt-2"
      @input="isAdvancedSearchVisible = false"
    />

    <div v-if="data" class="mt-3">
      <v-layout wrap :style="{ margin: '-8px' }">
        <v-flex xs12 sm3 class="pa-2">
          <OverviewCard :title="$t('total_user_receive_message')">
            <OverviewCounter :value="data.totalUsers" />
          </OverviewCard>
        </v-flex>
        <v-flex xs12 sm6 class="pa-2">
          <OverviewCard title="Enter, Banner">
            <LineFriendChart
              :friend="data.totalFriend"
              :friend-percent="data.totalFriendPercent"
              :non-friend="data.totalNonFriend"
              :non-friend-percent="data.totalNonFriendPercent"
            />
          </OverviewCard>
        </v-flex>
        <v-flex xs12 sm3 class="pa-2">
          <OverviewCard :title="$t('total messages')" :value="data.totalMessages">
            <OverviewCounter :value="data.totalMessages" />
          </OverviewCard>
        </v-flex>
      </v-layout>

      <DataTable :items="items" class="mt-3" @select="selectedItem = $event" />
    </div>
    <div v-else>
      <p class="text-xs-center ma-0 py-5">{{ $t('no_data') }}</p>
    </div>

    <CustomerListDialog
      v-if="!!selectedItem"
      :beacon-id="selectedItem.beacon_id"
      :filters="filters"
      @close="selectedItem = undefined"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import { handleApiError } from '@/api/util'
import beaconApi from '@/api/beacon'
import OverviewCard from './OverviewCard'
import OverviewCounter from './OverviewCounter'
import LineFriendChart from './LineFriendChart'
import AdvancedSearch from './AdvancedSearch'
import DataTable from './DataTable'
import CustomerListDialog from './CustomerListDialog'

export default {
  components: {
    OverviewCard,
    OverviewCounter,
    LineFriendChart,
    AdvancedSearch,
    DataTable,
    CustomerListDialog
  },
  data() {
    return {
      data: undefined,
      filters: {
        date_from: dayjs().format('YYYY-MM-DD'),
        date_to: dayjs().format('YYYY-MM-DD')
      },
      isAdvancedSearchVisible: false,
      selectedItem: undefined
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    items() {
      try {
        return Object.entries(this.data.beacon.data).map(([key, value]) => ({
          beacon_id: key,
          ...value
        }))
      } catch (error) {
        return []
      }
    }
  },
  watch: {
    filters: {
      immediate: true,
      handler() {
        this.fetch()
      }
    }
  },
  methods: {
    async fetch() {
      try {
        this.$store.dispatch('loading')

        const response = await this.getData()

        if (response.status === 200) {
          this.data = response.data.data
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    getData(filters) {
      const { beacon_id_list = [], ...rest } = this.filters

      return beaconApi.getAnalyticsUserMessages({
        config: {
          pageid: this.selectedBot.pageid,
          data: {
            ...rest,
            beacon_id_list: beacon_id_list.join(','),
            ...filters
          }
        }
      })
    },
    async exportData() {
      try {
        this.$store.dispatch('loading')

        const { data, total } = this.transformExportData()

        const { date_from, date_to } = this.filters

        const rows = [
          [
            `จาก ${dayjs(date_from).format('DD/MM/YYYY')} ถึง ${dayjs(date_to).format(
              'DD/MM/YYYY'
            )}`
          ],
          [],
          ['วิเคราะห์หน้า Dashboard'],
          [
            'Beacon ID',
            'Beacon Name',
            'จำนวนผู้ใช้ที่ได้รับ',
            'Enter',
            'Banner',
            'จำนวนข้อความทั้งหมด'
          ],
          ...data.map((item) => [
            item.beacon_id,
            item.beacon_name,
            item.totalUsers,
            item.totalFriend,
            item.totalNonFriend,
            item.totalMessages
          ]),
          [
            '',
            '',
            total.sumTotalUsers,
            total.sumTotalFriend,
            total.sumTotalNonFriend,
            total.sumTotalMessages
          ]
        ]

        const workBook = XLSX.utils.book_new()
        const workSheet = XLSX.utils.aoa_to_sheet(rows)
        XLSX.utils.book_append_sheet(workBook, workSheet, 'Dashboard')
        XLSX.writeFile(workBook, 'beacon-user-messages.xlsx')
      } catch (error) {
        handleApiError(error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    transformExportData() {
      try {
        const tempData = this.items

        let sumTotalUsers = 0
        let sumTotalFriend = 0
        let sumTotalNonFriend = 0
        let sumTotalMessages = 0

        tempData.map((item) => {
          sumTotalUsers += item.totalUsers
          sumTotalFriend += item.totalFriend
          sumTotalNonFriend += item.totalNonFriend
          sumTotalMessages += item.totalMessages
        })

        let data = {
          data: tempData,
          total: { sumTotalUsers, sumTotalFriend, sumTotalNonFriend, sumTotalMessages }
        }

        return data
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Dashboard/index.vue